import angular from 'angular';
import {
  userService,
  loaderService,
  ssDialogService,
  reportsSharedModelService,
} from 'app/services';
import { actionIcon } from 'app/components/global';

import reportTypes from './reportTypes';

import directive from './generated-reports.directive';
import controller from './generated-reports.controller';


export const generatedReportsRouteConfig = {
  template: require('./generated-reports.html'),
  controller: 'GeneratedReportsController',
  controllerAs: 'generatedReportsVM',
};

export default angular.module('app.components.reports.generatedReports', [
  userService,
  loaderService,
  ssDialogService,
  reportsSharedModelService,
  actionIcon,
  reportTypes,
])
  .directive('generatedReports', directive)
  .controller('GeneratedReportsController', controller)
  .name;

console.log('app.components.reports.generatedReports created');
